export default "__VITE_ASSET__8c45b11d__"